import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useCrmFacebookLeadFormIdDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (id: number) => {
      const res = await $api.delete(`/v1/crm/facebook/lead-form/${id}`);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_APP_PIPE]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_ID]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_PIPE_STATUS]);
      }
    }
  );
};
